var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDirectorCardCreator = function SvgIconDirectorCardCreator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "#DA613A",
    rx: 18
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.375 12.75a.8.8 0 0 0-.613.262l-8.75 8.75a.846.846 0 0 0 0 1.226c.35.35.875.35 1.226 0l8.75-8.75a.846.846 0 0 0 0-1.226.8.8 0 0 0-.613-.262"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.375 12.75H14.5c-.525 0-.875.35-.875.875s.35.875.875.875h7v7c0 .525.35.875.875.875s.875-.35.875-.875v-7.875c0-.525-.35-.875-.875-.875"
  })));
};
export default SvgIconDirectorCardCreator;